import { flatten } from 'es-toolkit/compat';

import { isPresent } from '../../../../../utils/typescriptUtil';
import { isFreeTrialLevel } from '../../../common/termedLevel/freeTrialLevel';
import type { OverviewResource } from '../redux/types';
import type { ProductRatePlan } from '../types';
import { isResourceActiveForLevel } from './serviceOverviewLevelService';

export function findSmallestNonFreeTrialLevel(tabList: ProductRatePlan[][]): string {
    const levels = flatten(tabList)
        .map(productRatePlan => productRatePlan.level)
        .filter(level => !isFreeTrialLevel(level))
        .filter(isPresent);
    return levels.sort()[0];
}

export function getTabKey(ratePlans: ProductRatePlan[]): string | undefined {
    return ratePlans
        .map(ratePlan => ratePlan.level)
        .filter(level => !isFreeTrialLevel(level))
        .filter(isPresent)[0];
}

function tabHasVisibleResources(ratePlans: ProductRatePlan[], resources: OverviewResource[]): boolean {
    return ratePlans.some(ratePlan => {
        const level = ratePlan.level;
        return level ? resources.some(isResourceActiveForLevel(level)) : false;
    });
}

export function getVisibleTabs(tabList: ProductRatePlan[][], resources: OverviewResource[]): ProductRatePlan[][] {
    return tabList
        .map(ratePlans =>
            ratePlans.filter(ratePlan => !(ratePlan.legacy && !tabHasVisibleResources([ratePlan], resources)))
        )
        .filter(ratePlans => ratePlans.length > 0);
}

export function findDefaultSelectedTab(tabList: ProductRatePlan[][], resources: OverviewResource[]): string {
    const visibleTabs = getVisibleTabs(tabList, resources);
    const activeTabKeys = visibleTabs
        .filter(ratePlans => tabHasVisibleResources(ratePlans, resources))
        .map(getTabKey)
        .filter(isPresent)
        .sort();

    return activeTabKeys[0] ?? findSmallestNonFreeTrialLevel(visibleTabs.length > 0 ? visibleTabs : tabList);
}
